import axios from 'axios'
import notifService from '../../services/notifService'

export const getBundling = async (context, pagination) => {
  let res = await axios
    .get('/cms/bundlings', {
      params: pagination
    })
    .then(response => {
      context.commit('getBundling', response.data.data)

      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const listBundling = async (context, pagination) => {
  axios
    .get('/cms/bundlings', {
      params: pagination
    })
    .then(response => {
      context.commit('listBundling', response.data.data)
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const addBundling = async (_context, val) => {
  return await axios
    .post('/cms/bundlings/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })
}

export const editBundling = async (_context, val) => {
  return await axios
    .put('/cms/bundlings/edit/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })
}

export const deleteBundling = async (_context, val) => {
  return await axios
    .delete('/cms/bundlings/delete/' + val)
    .then(response => {
      return true
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })
}

export const bundlingForm = (context, val) => {
  context.commit('bundlingForm', val)
}
